module.exports = __webpack_public_path__ + "img/HomePage-elearning.c1dda48.webp";